// lookup for max-height reasons
<template >
  <div :key="'composition-api-basic-example-component'">
    <pre><code
  class="javascript"
  style="max-height: 700px"
  data-trim
  data-noescape
  data-line-numbers="1-99"
  v-html="exampleText"
></code></pre>
  </div>
</template>

<script>
export default {
  data() {
    return {
      exampleText: `import { reactive, computed } from 'vue'

export default {
  setup() {
    const state = reactive({
      count: 0,
      double: computed(() => state.count * 2)
    })

    function increment() {
      state.count++
    }

    return {
      state,
      increment
    }
  }
}`
    };
  }
};
</script>
